import { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import cn from 'classnames'
import styles from './VNCartServiceCharge.module.scss'
import { centsToDollars } from '../../utils/formatters'
import { getMenuServiceCharge } from '../../selectors/items'
import { getSubtotal } from '../../selectors/cart'
import { calculateServiceCharge } from '../../utils/totalUtils'

const VNCartServiceCharge = ({ className }) => {
  const classNames = cn(styles.VNCartServiceCharge, className)
  const serviceCharge = useSelector(getMenuServiceCharge)
  const subtotal = useSelector(getSubtotal)

  const serviceChargeTotalInCents = useMemo(() => calculateServiceCharge(serviceCharge, subtotal) ?? 0, [serviceCharge, subtotal])

  if (serviceChargeTotalInCents <= 0) {
    return null
  }

  return (
    <div className={classNames}>
      <div className={cn([styles.label])}>Service Charge</div>
      <div className={cn([styles.price])}>{centsToDollars(serviceChargeTotalInCents)}</div>
    </div>
  )
}

export default memo(VNCartServiceCharge)
